
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GoldRateStateData {
    gold: {
        '18K': number,
        '22K': number,
        '24K': number,
        '24K995': number,
    },
    silver: number[],
    timestamp: number
}

const initialState: GoldRateStateData = {
} as GoldRateStateData;

const goldRateSlice = createSlice({
    name: "goldRate",
    initialState,
    reducers: {
        setGoldRate (state, action: PayloadAction<GoldRateStateData>) {
            return action.payload;
        },
        resetGoldRate () {
            return initialState;
        }
    },
})

export const {setGoldRate, resetGoldRate} = goldRateSlice.actions;
export default goldRateSlice.reducer;